import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCursorDoubleClick3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "cursor-double-click-3" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.536,11.568l2.68,8.931a.83.83,0,0,0,1.382.349l1.365-1.365,3.522,3.522a.83.83,0,0,0,1.174,0l2.348-2.348a.83.83,0,0,0,0-1.174l-3.522-3.522L20.85,14.6a.83.83,0,0,0-.348-1.382l-8.932-2.68A.831.831,0,0,0,10.536,11.568Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.723,10.5A10.5,10.5,0,1,0,10.5,21.721"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.813,9A6,6,0,1,0,9,16.811"
		})
	]
});
export default SvgCursorDoubleClick3;
